// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"260":"48ff7cd1","787":"8cbf2b63","874":"c9b629ee"}[chunkId] + ".chunk.js";
};